import React from 'react'
import Box from '@mui/material/Box';
// import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

export default function Menu() {

    const handleClick = (value) => {
        // window.open(`https://hyper-active.com/docs/${value}`, '_blank');
    }

    return (
        <Box height={'100%'} position={'fixed'} width={'100%'} overflow={'scroll'}>
            <Box sx={{ position: 'fixed', zIndex: -1, width: 1, height: 1 }}>
                <Box component={'img'} src='https://hyper-active.com/images/2025/03/sportbar_background.svg' width={1} height={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box display={'flex'} flexDirection={'column'} justifyContent={'start'} alignItems={'center'} gap={'50px'} paddingBottom={'70px'} paddingTop={'30px'} height={'100%'}>
                <Box justifyContent={'center'} display={'flex'} width={'100%'} alignItems={'center'}>
                    <Box component={'img'} src='https://hyper-active.com/images/2025/03/sportbar_logo.svg' width={'50%'} height={1} sx={{ objectFit: 'cover' }} />
                </Box>
                <Box display={'flex'} flexDirection={'column'} width={'100%'} gap={'40px'}>
                    <Box sx={{ justifyContent: 'center', display: 'flex' }}>
                        <Button variant='contained' LinkComponent={Link} to="./SportsBar_Menu_Finale" sx={{ backgroundColor: '#B5332F', paddingY: 2, paddingX: 4, border: 'solid 2px', borderColor: '#B5332F', width: { xs: '70%', sm: '300px' }, '&:hover': { background: '#FFF', color: '#B5332F' } }} onClick={() => handleClick('')}>
                            Food Menu
                        </Button>
                    </Box>
                    <Box sx={{ justifyContent: 'center', display: 'flex' }}>
                        <Button variant='contained' LinkComponent={Link} to="./Bar_Menu" sx={{ backgroundColor: '#B5332F', paddingY: 2, paddingX: 4, border: 'solid 2px', borderColor: '#B5332F', width: { xs: '70%', sm: '300px' }, '&:hover': { background: '#FFF', color: '#B5332F' } }} onClick={() => handleClick('Bar_Menu.pdf')}>
                            Cocktail Menu
                        </Button>
                    </Box>
                    {/* <Box sx={{ justifyContent: 'center', display: 'flex' }}>
                        <Button variant='contained' LinkComponent={Link} to="./Ofertat" sx={{ backgroundColor: '#B5332F', paddingY: 2, paddingX: 4, border: 'solid 2px', borderColor: '#B5332F', width: { xs: '70%', sm: '300px' }, '&:hover': { background: '#FFF', color: '#B5332F' } }} onClick={() => handleClick('Bar_Menu.pdf')}>
                            Ofertat
                        </Button>
                    </Box> */}
                    <Box sx={{ justifyContent: 'center', display: 'flex' }}>
                        <Button variant='contained' LinkComponent={Link} to="./Bar_Games" sx={{ backgroundColor: '#B5332F', paddingY: 2, paddingX: 4, border: 'solid 2px', borderColor: '#B5332F', width: { xs: '70%', sm: '300px' }, '&:hover': { background: '#FFF', color: '#B5332F' } }} onClick={() => handleClick('Bar_Menu.pdf')}>
                            Bar Games
                        </Button>
                    </Box>
                    {/* <Box sx={{ justifyContent: 'center', display: 'flex' }}>
                        <Button variant='contained' LinkComponent={Link} to="./Lodra_Bar" sx={{ backgroundColor: '#B5332F', paddingY: 2, paddingX: 4, border: 'solid 2px', borderColor: '#B5332F', width: { xs: '70%', sm: '300px' }, '&:hover': { background: '#FFF', color: '#B5332F' } }} onClick={() => handleClick('Bar_Menu.pdf')}>
                            Lodra Bar
                        </Button>
                    </Box> */}
                </Box>
            </Box>

            {/* <Grid container spacing={4}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ paddingX: '0 !important', justifyContent: 'center' }}>

                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ paddingX: '!important', justifyContent: 'center' }}>
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            
                        </Grid>
                    </Grid>
                </Grid>
            </Grid> */}
        </Box>
    )
}